import React from 'react';
import { Input } from '../../ui/Input';
import { TextArea } from '../../ui/TextArea';
import { AvatarUpload } from '../../ui/AvatarUpload';

export const TabBasics = ({ card, updateCard }) => {
  return (
    <div className="space-y-6">
      <AvatarUpload 
        url={card.profile_image_url} 
        onUpload={(url) => updateCard('profile_image_url', url)} 
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input 
          label="Public Full Name" 
          value={card.full_name || ''} 
          onChange={e => updateCard('full_name', e.target.value)} 
        />
        <Input 
          label="Pronouns" 
          value={card.pronouns || ''} 
          onChange={e => updateCard('pronouns', e.target.value)} 
          placeholder="e.g. they/them" 
        />
        <Input 
          label="Job Title" 
          value={card.job_title || ''} 
          onChange={e => updateCard('job_title', e.target.value)} 
        />
        <Input 
          label="Company" 
          value={card.company_name || ''} 
          onChange={e => updateCard('company_name', e.target.value)} 
        />
        <Input 
          label="Location" 
          value={card.location || ''} 
          onChange={e => updateCard('location', e.target.value)} 
          className="md:col-span-2" 
        />
      </div>
      <TextArea 
        label="Bio" 
        value={card.bio || ''} 
        onChange={e => updateCard('bio', e.target.value)} 
        rows={4}
      />
    </div>
  );
};